module.exports = __webpack_public_path__ + "assets/img/3a6f711f62a8188675ddfc57da806825.svg";